import React, {useMemo} from 'react';
import {IoCheckmarkDoneSharp} from "react-icons/io5";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import {FaBookmark, FaRegBookmark, FaRegStar, FaStar} from "react-icons/fa";
import userMessageFilter from "../utils/user-message-filter.jsx";

const UserMessagesList = ({viewSent, messagesByUser, messages, sortBy, messagesChecked, handleChecked, selected, handleDetails, filters}) => {
    let arrayToShow = viewSent ? messagesByUser?.data ?? [] : messages;

    const sorted = userMessageFilter(arrayToShow, filters)?.sort((a, b) => {
        if (sortBy === 'new') {
            if (a.status === 'NEW' && b.status !== 'NEW') return -1;

            if (a.status !== 'NEW' && b.status === 'NEW') return 1;
        }

        if (sortBy === 'id') return b.id - a.id;

        if (sortBy === 'important') return (b.important === a.important) ? 0 : b.important ? 1 : -1;

        if (sortBy === 'favorite') return (b.favorite === a.favorite) ? 0 : b.favorite ? 1 : -1;

        return 0;
    });

    return (
        <div className={"flex flex-col gap-1 overflow-auto max-h-[95%]"}>
            {
                sorted?.map(item => (
                    <div
                        className={"group border border-[#bdbdbd] rounded-md flex justify-between items-center cursor-pointer hover:bg-[#D5E2FF]" + (messagesChecked.includes(item.id) ? " bg-[#D5E2FF]" : "") + (selected === item.id ? " bg-[#D5E2FF]" : "")}
                        key={item.id}
                    >
                        <div className="flex gap-1.5 items-center ml-[10px] text-center">
                            {
                                !viewSent &&
                                <InputCheckbox
                                    checked={messagesChecked.includes(item.id)}
                                    onChange={({target: {checked}}) => handleChecked(checked, item)}
                                />
                            }

                            { item.important && <FaBookmark title={"Importante"} color={"#ffca28"}/>}
                            { !item.important && <FaRegBookmark />}

                            { !viewSent && item.favorite && <FaStar color={"#ffca28"}/>}
                            { !viewSent && !item.favorite && <FaRegStar />}
                        </div>
                        <div className={"flex-1 shrink-0 basis-0 overflow-hidden p-2.5" + (item?.status === "NEW" ? " font-bold" : "")} onClick={() => handleDetails(item)}>
                            <div className="text-[15px] truncate">{item.title}</div>
                            <div className="user-created">
                                De: {item.userCreatedName} {item.userCreatedNameWar ? "(" + item.userCreatedNameWar + ")" : ""}
                            </div>
                        </div>
                        {
                            !viewSent &&
                            <div style={{padding: "10px 10px 10px 0"}} onClick={() => handleDetails(item)}>
                                {item.status === "VIEWED" && <IoCheckmarkDoneSharp className={"check-double-viewed float-end me-1"}  title={"Visualizado"}/>}
                            </div>
                        }
                    </div>
                ))
            }
        </div>
    );
};

export default UserMessagesList;